import { Group, Text, Container, Card, Flex, Button } from '@mantine/core';
import { useState, useEffect } from 'react';
import { useDocumentTitle } from '@mantine/hooks';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { useNavigate } from "react-router-dom";
import { HelpTip } from "../../components/GeneralComponent/GeneralComponent";
import GeneralComponentApi from "../../api/GeneralComponentApi";

export function BillingDetails() {
  useDocumentTitle("Visiopt - Billing");
  const navigate = useNavigate();

  const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
  const [billingPortalUrl, setBillingPortalUrl] = useState('');
  const [cancelAccountMsg, setCancelAccountMsg] = useState('');
  const [showBillingPortal, setShowBillingPortal] = useState(false);

  const handleHeaderMenuComponentChange = (Value:any) => {
    setSelectedMemberWebsite(Value);
  };

  useEffect(() => {
    GeneralComponentApi.getbillingdetails()
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setBillingPortalUrl(data.data.biling_portal_url);
        setCancelAccountMsg(data.data.cancelled_account_msg);
        setShowBillingPortal(data.data.biling_portal_url_show);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }, [navigate]);

  const handleAccessBillingPortal = () => {
    window.open(billingPortalUrl, '_blank');
  };


	return (
		<>
      <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
      <Container size="xl">
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Group position="apart" mb="xs">
            <Text weight={500}>BILLING <HelpTip helpId={166} /></Text>
          </Group>
          <Text mt={20}>{cancelAccountMsg}</Text>
          {showBillingPortal && (
            <>
              <Flex justify="center" mt={10}>
                <Text weight={500} align="center" style={{ fontSize: "20px" }}>If you would like to upgrade or downgrade your account, please contact support@visiopt.com</Text>
              </Flex>
              <Flex justify="center" mt={20} mb={10}>
                <Button style={{ fontSize: "18px" }} onClick={handleAccessBillingPortal}>Access Your Billing Portal</Button>
              </Flex>
            </>
          )}
        </Card>
      </Container>
		</>
	);
}